import { observer } from 'mobx-react';
import { autoinject, bind, inject } from 'Mri.Web.Common';
import * as React from 'react';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledButtonDropdown } from 'reactstrap';
import { AccountStore } from '../Account/AccountStore';
import { BsBoxArrowRight } from '@react-icons/all-files/bs/BsBoxArrowRight';
import { BsExclamationTriangle } from '@react-icons/all-files/bs/BsExclamationTriangle';
import { BsFillPersonFill } from '@react-icons/all-files/bs/BsFillPersonFill';
import { BsGearFill } from '@react-icons/all-files/bs/BsGearFill';
import { BsXCircle } from '@react-icons/all-files/bs/BsXCircle';
import { BsDatabaseX } from 'react-icons/bs';
import { action } from 'mobx';
import { AppStore } from './AppStore';

@autoinject
@observer
export class UserMenu extends React.Component {
    public render() {
        const { isLoggedIn, user } = this.accountStore;
        const authority = (window as any).initialOidcConfig ? (window as any).initialOidcConfig.authority : '';

        if (isLoggedIn && user) {
            return (
                <UncontrolledButtonDropdown>
                    <DropdownToggle color="link">
                        <BsFillPersonFill style={{ fontSize: 22 }} />
                    </DropdownToggle>
                    <DropdownMenu end className="p-0 dropdown-padding">
                        <DropdownItem className="py-0 border-bottom" disabled>
                            <small>{user.userName}</small>
                        </DropdownItem>

                        <DropdownItem tag="a" href={`${authority}/preferences`} className="text-header fw-bold py-0">
                            <BsGearFill style={{ marginRight: 6 }} />
                            Preferences
                        </DropdownItem>

                        <DropdownItem
                            tag="a"
                            href="http://mri-gitlab.noc/mri/product_windows/issues/new"
                            className="text-header fw-bold py-0"
                        >
                            <BsExclamationTriangle style={{ marginRight: 6 }} />
                            Report an Issue
                        </DropdownItem>

                        <DropdownItem tag="a" onClick={this.clearAndReload} className="text-header fw-bold py-0">
                            <BsDatabaseX style={{ marginRight: 6 }} />
                            Clear Local Storage
                        </DropdownItem>

                        {user.isImpersonating && (
                            <DropdownItem onClick={this.logout} className="text-danger fw-bold py-0">
                                <BsXCircle style={{ marginRight: 6 }} />
                                Stop Impersonating
                            </DropdownItem>
                        )}

                        <DropdownItem onClick={this.logout} className="text-header fw-bold py-0 border-top">
                            <BsBoxArrowRight style={{ marginRight: 6, fontSize: 20 }} />
                            Logout
                        </DropdownItem>
                    </DropdownMenu>
                </UncontrolledButtonDropdown>
            );
        } else {
            return (
                <a
                    href={`${authority}/account/login`}
                    className="btn-link d-block px-5 text-header float-end h-100 fw-bold"
                >
                    Login
                </a>
            );
        }
    }

    @bind
    @action
    private clearAndReload() {
        localStorage.clear();
        sessionStorage.clear();
        window.location.reload();
    }

    @bind
    private logout(event: React.MouseEvent<HTMLButtonElement>) {
        if (typeof sessionStorage != 'undefined') sessionStorage.clear();
        if (typeof localStorage != 'undefined') localStorage.clear();
        this.accountStore.signoutRedirect();
    }

    @inject
    private accountStore!: AccountStore;
    @inject
    private appStore!: AppStore;
}
